module.exports = __webpack_public_path__ + "./images/p28.JPG?1186cde439e0bf5daf9fc8c53e904d1d";


//////////////////
// WEBPACK FOOTER
// ./src/products/p28.JPG
// module id = 64
// module chunks = 0